module.exports = __webpack_public_path__ + "static/media/folder.546fd196.svg";